<div class="rechtstext">
  <h1>Impressum</h1>

  <h2>Angaben gemäß § 5 Digitale-Dienste-Gesetz (DDG)</h2>
  <p>
    IT-Service Karsten Fischer<br />
    Martinshof 2<br />
    88410 Bad Wurzach<br />
    Deutschland
  </p>

  <h2>Kontakt</h2>
  <p>
    Telefon: +49 (0)7568 30 90 137<br />
    E-Mail: <a href="mailto:info@it-karsten-fischer.de">info@it-karsten-fischer.de</a>
  </p>

  <h2>Vertreten durch</h2>
  <p>Karsten Fischer (Inhaber)</p>

  <h2>Verantwortlich für den Inhalt gemäß § 18 Abs. 2 MStV</h2>
  <p>Karsten Fischer, Anschrift wie oben</p>

  <h2>Unternehmensform</h2>
  <p>Einzelunternehmen</p>

  <h2>Wirtschafts-Identifikationsnummer</h2>
  <p>
    Wirtschafts-Identifikationsnummer gemäß § 139c Abgabenordnung (AO): DE307304411-00001
  </p>

  <h2>Streitbeilegung</h2>
  <p>
    Die Europäische Kommission stellt eine Plattform zur Online-Streitbeilegung (OS) bereit:
    <a href="https://ec.europa.eu/consumers/odr/" target="_blank" rel="noopener noreferrer"
      >https://ec.europa.eu/consumers/odr/</a
    >
    – unsere E-Mail-Adresse finden Sie oben im Impressum.
  </p>
  <p>
    Wir sind nicht bereit und nicht verpflichtet, an Streitbeilegungsverfahren vor einer
    Verbraucherschlichtungsstelle teilzunehmen.
  </p>

  <h2>Haftung für Inhalte</h2>
  <p>
    Als Diensteanbieter sind wir gemäß § 7 Abs. 1 DDG für eigene Inhalte auf diesen Seiten nach den
    allgemeinen Gesetzen verantwortlich.
  </p>
  <p>
    Nach §§ 8 bis 10 Digitale-Dienste-Gesetz (DDG) sind wir als Diensteanbieter jedoch nicht
    verpflichtet, übermittelte oder gespeicherte fremde Informationen zu überwachen oder nach
    Umständen zu forschen, die auf eine rechtswidrige Tätigkeit hinweisen.
  </p>

  <h2>Haftung für Links</h2>
  <p>
    Unsere Website enthält gegebenenfalls Links zu externen Websites Dritter, auf deren Inhalte wir
    keinen Einfluss haben. Deshalb können wir für diese fremden Inhalte auch keine Gewähr
    übernehmen.
  </p>

  <h2>Urheberrecht</h2>
  <p>
    Die durch den Seitenbetreiber erstellten Inhalte und Werke auf diesen Seiten unterliegen dem
    deutschen Urheberrecht.
  </p>
</div>
